import Header from "../../components/header";
import Footer from "../../components/footer";
import Input from "../../components/shared/Input";
import Button from "../../components/shared/Button";
import { useState } from "react";
import { toast } from "react-toastify";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");

  const handleForgetPassword = async () => {
    toast.info("If an account with that email exists, a password reset link has been sent.");
  };

  return (
    <div className={`w-full h-full flex flex-col bg-[#000000]`}>
      <Header />
      <div
        style={{
          backgroundImage: "url(assets/img/landing/landing-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex flex-col items-center w-full h-screen relative pt-6"
      >
        <div className="w-full md:w-[676px] h-full flex flex-col items-center mt-5 z-10 mb-[166px]">
          <img
            alt="modal-logo"
            src="assets/img/login/logo.png"
            className="w-[252px] md:w-[276px]"
          />
          <p className="text-[16px] md:text-[20px]">
            Forgot your password?
          </p>
          <p className="text-[13px] md:text-[16px]">
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <div className="flex flex-col gap-6 w-full mt-8 px-20">
            <Input
              className="!h-[51px]"
              type="email"
              onChange={(value) => setEmail(value)}
              placeholder="Email"
            />
            <Button
              onClick={handleForgetPassword}
              className="w-full !h-[51px]"
            >
              Send Reset Link
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgetPassword;